export default element => {
  const inputs = ["input", "textarea"];
  return element && (element.isContentEditable || inputs.indexOf(element.tagName.toLowerCase()) !== -1);
};
